import { createFileRoute } from '@tanstack/react-router'
import SocialNetworkExercise from '@/components/Movement/SocialNetworkExercise'
import { z } from 'zod'

const socialNetworkSearchSchema = z.object({
  view: z.enum(['instructions', 'circle-diagram', 'reflection', 'review', 'summary']).optional(),
})

export const Route = createFileRoute('/(content)/adults/exercises/(shared)/social-network/exercise')({
  component: RouteComponent,
  validateSearch: (search) => socialNetworkSearchSchema.parse(search),
  head: () => ({
    meta: [
      {
        title: "My Social Network Exercise - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "weakness.exercises.network",
    navbar: {
      showTitle: true,
    },
  }),
})

function RouteComponent() {
  const { view } = Route.useSearch()
  return <SocialNetworkExercise initialView={view} />
}
